import { motion } from "framer-motion";
import { Play } from "lucide-react";

const EMOTIONS = ["Overwhelm", "Anger", "Grief", "Anxiety", "The freeze"];

export default function ReliefSpotlight() {
  return (
    <section
      id="relief"
      data-testid="wynn-relief"
      className="relative border-t border-[#F4F1EC]/10 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-70"
        style={{
          background:
            "radial-gradient(50% 55% at 18% 25%, rgba(255,150,200,0.22) 0%, rgba(7,6,8,0) 60%), radial-gradient(50% 55% at 85% 80%, rgba(180,140,230,0.20) 0%, rgba(7,6,8,0) 65%)",
        }}
      />
      <div className="relative max-w-[1280px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-12 md:gap-10 items-center">
          {/* Text */}
          <div className="col-span-12 md:col-span-6 order-2 md:order-1">
            <div className="text-[11px] uppercase tracking-[0.32em] text-[#FFB7C6] font-body">
              The flagship · in the full app
            </div>
            <h2 className="mt-4 font-display tracking-tight leading-[1.02] text-[clamp(2.2rem,5vw,3.8rem)] font-medium text-[#F4F1EC]">
              When the feeling is too big,{" "}
              <span className="italic font-light text-aurora">press play</span>.
            </h2>
            <p className="mt-6 font-body text-[#F4F1EC]/75 text-lg leading-[1.75] max-w-xl">
              Short art-therapy tool videos, made by hand for the moments of strong
              emotion — the anger, the grief, the overwhelm, the ache that won&apos;t
              move. Reach for one, follow along, and let your hands do the work until
              the wave passes. Instant relief and gentle emotional self-regulation —
              not talk, not theory, something to <em>do</em>.
            </p>

            <div className="mt-8 flex flex-wrap gap-2">
              {EMOTIONS.map((e) => (
                <span
                  key={e}
                  className="font-body text-[11px] uppercase tracking-[0.18em] text-[#F4F1EC]/70 border border-[#F4F1EC]/15 px-3 py-1.5"
                >
                  {e}
                </span>
              ))}
            </div>
          </div>

          {/* Play card */}
          <div className="col-span-12 md:col-span-6 order-1 md:order-2">
            <motion.div
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
              data-testid="relief-play-card"
              className="relative aspect-[4/3] border border-[#F4F1EC]/15 overflow-hidden group"
            >
              <div
                aria-hidden
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(255,183,198,0.35) 0%, rgba(230,191,255,0.3) 45%, rgba(168,230,255,0.28) 100%)",
                }}
              />
              <div aria-hidden className="absolute inset-0 wynn-grain opacity-40" />
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="h-20 w-20 rounded-full bg-[#070608]/70 backdrop-blur-sm border border-[#F4F1EC]/30 inline-flex items-center justify-center transition-transform group-hover:scale-105">
                  <Play size={28} strokeWidth={1.4} className="text-[#F4F1EC] ml-1" />
                </span>
                <span className="mt-6 font-display text-[24px] italic font-light text-[#F4F1EC]">
                  Art therapy tool
                </span>
                <span className="mt-2 text-[10px] uppercase tracking-[0.3em] text-[#F4F1EC]/70 font-body">
                  2–5 min · for strong emotions
                </span>
              </div>
              <div className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.24em] text-[#F4F1EC]/80 font-body bg-[#070608]/50 px-2.5 py-1 border border-[#F4F1EC]/20">
                Coming in the full app
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
